import { render } from "./PreviewPane.vue?vue&type=template&id=2ff6dc66&scoped=true"
import script from "./PreviewPane.vue?vue&type=script&lang=js"
export * from "./PreviewPane.vue?vue&type=script&lang=js"

import "./PreviewPane.vue?vue&type=style&index=0&id=2ff6dc66&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff6dc66"]])

export default __exports__